import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const DocumentOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M19.51 6.69 15.5 2.81c-.32-.31-.74-.48-1.19-.48H7.62C5.62 2.33 4 3.9 4 5.83v12.34c0 1.93 1.62 3.5 3.62 3.5h8.77c2 0 3.62-1.57 3.62-3.5V7.84c0-.43-.18-.85-.49-1.15h-.01ZM14.8 4.36l2.93 2.83H14.8V4.36Zm1.58 15.71H7.62c-1.11 0-2.02-.85-2.02-1.9V5.83c0-1.05.91-1.9 2.02-1.9h5.58v4.06c0 .44.36.8.8.8h4.4v9.38c0 1.05-.91 1.9-2.02 1.9Z" />
      <Path d="M16 11.19H8.16c-.44 0-.8.36-.8.8 0 .44.36.8.8.8H16c.44 0 .8-.36.8-.8 0-.44-.36-.8-.8-.8ZM16 15.19H8.16c-.44 0-.8.36-.8.8 0 .44.36.8.8.8H16c.44 0 .8-.36.8-.8 0-.44-.36-.8-.8-.8Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default DocumentOutlined
